<div class="component-wrapper">

    <header>
        <h1 class="title" [innerHTMLBypassXSS]="title"></h1>
        <p class="subtitle" [innerHTMLBypassXSS]="subtitle"></p>
    </header>

    <ng-container *ngIf="showList">
        <kendo-grid [data]="gridData" (dataStateChange)="dataStateChange($event)" [sortable]="sortSettings"
            [sort]="state.sort" [navigable]="true" [class]="'gutachtenOverviewGrid'" [resizable]="true">
            <kendo-grid-column field="anfrageNummer" [width]="60">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.number' | translate}}" class="column-head">
                        {{'review.tablecolumn.number' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="two-lines-overflow" [title]="dataItem.anfrageNummer">
                        {{ dataItem.anfrageNummer }}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="anfrageTitel" [width]="160">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.title' | translate}}" class="column-head">
                        {{'review.tablecolumn.title' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button class="titel-button" (click)="onButtonClicked(dataItem)"
                        [title]="formatTitle(dataItem?.anfrageTitel)">
                        <span class="two-lines-overflow">
                            {{ formatTitle(dataItem?.anfrageTitel) }}
                        </span>
                    </button>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="antragstellerName" [width]="160">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.applicant' | translate}}" class="column-head">
                        {{'review.tablecolumn.applicant' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="two-lines-overflow" [title]="dataItem?.antragstellerName">
                        {{ dataItem?.antragstellerName }}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="foerdersumme" class="number-column" headerClass="number-column-head" [width]="70">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.funding' | translate}}" class="column-head">
                        {{'review.tablecolumn.funding' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="two-lines-overflow" [title]="formatCurrency(dataItem?.foerdersumme)">
                        {{ formatCurrency(dataItem?.foerdersumme) }}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="statuscode" [width]="80">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.status' | translate}}" class="column-head">
                        {{'review.tablecolumn.status' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="two-lines-overflow" [title]="formatStatusGrund(dataItem)">
                        {{ formatStatusGrund(dataItem) }}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="gutachtenAbgegebenAm" [width]="50">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.submitted' | translate}}" class="column-head">
                        {{'review.tablecolumn.submitted' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="two-lines-overflow" [title]="formatDate(dataItem.gutachtenAbgegebenAm)">
                        {{ formatDate(dataItem.gutachtenAbgegebenAm) }}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="bewertung" class="number-column" headerClass="number-column-head" [width]="40">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.evaluation' | translate}}" class="column-head">
                        {{'review.tablecolumn.evaluation' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="two-lines-overflow" [title]="formatBewertung(dataItem.bewertung)">
                        {{ formatBewertung(dataItem.bewertung) }}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ausschreibungsName" [width]="160">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.tender' | translate}}" class="column-head">
                        {{'review.tablecolumn.tender' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="two-lines-overflow" [title]="dataItem.ausschreibungsName">
                        {{ dataItem.ausschreibungsName }}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="prioritaet" class="number-column" headerClass="number-column-head" [width]="40">
                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                    <span title="{{'review.tablecolumn.priority' | translate}}" class="column-head">
                        {{'review.tablecolumn.priority' | translate}}
                    </span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="two-lines-overflow" [title]="formatPriority(dataItem?.prioritaet)">
                        {{formatPriority(dataItem?.prioritaet)}}
                    </span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </ng-container>
    <span *ngIf="!showList" translate>review.none_available</span>
</div>